// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"c48687cf","197":"4e3c431c","265":"65ffc8ec","321":"efce7a86","731":"0e8cf834","789":"fda53452","823":"e22ea879"}[chunkId] + ".chunk.js";
};